/**
 * @generated SignedSource<<f65f4f458f0b1d6aa37b29ab01c5892f>>
 * @relayHash d6aa63ae0d028407eff5932b8a694e19
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d6aa63ae0d028407eff5932b8a694e19

import { ConcreteRequest } from 'relay-runtime';
export type PointOfCareType = "EMERGENCY_CALL" | "EXTERNAL_ASSISTANCE" | "GENERAL_PRACTITIONER" | "HOSPITAL_ELECTIVE" | "HOSPITAL_EMERGENCY_ROOM" | "INCOMPLETE_TELECONSULTATION" | "MEDICAL_EMERGENCY_OR_PERMANENCE" | "SPECIALIST" | "TELECARE";
export type TimeToTreatType = "LATER" | "URGENT" | "WITHIN12H" | "WITHIN14DAYS" | "WITHIN24H" | "WITHIN48H" | "WITHIN6H";
export type chTimeToTreatQuery$variables = Record<PropertyKey, never>;
export type chTimeToTreatQuery$data = {
  readonly timesToTreatByPointOfCare: ReadonlyArray<{
    readonly pointOfCare: PointOfCareType;
    readonly timesToTreat: ReadonlyArray<TimeToTreatType>;
  }>;
};
export type chTimeToTreatQuery = {
  response: chTimeToTreatQuery$data;
  variables: chTimeToTreatQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": "timesToTreatByPointOfCare",
    "args": null,
    "concreteType": "PointOfCareTimesToTreat",
    "kind": "LinkedField",
    "name": "ch_timesToTreatByPointOfCare",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pointOfCare",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timesToTreat",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "chTimeToTreatQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "chTimeToTreatQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "d6aa63ae0d028407eff5932b8a694e19",
    "metadata": {},
    "name": "chTimeToTreatQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1ac95bc44206f2bb87b7685d074e6dfc";

export default node;
